export class ItemConversa {
  id: number;
  descricao: string;
}
